import type { Config } from "tailwindcss";

export const colors = {
  blue: {
    base: "#486DF6",
    "01": '#91A7FA',
    "02": '#C4D0FC',
    "03": '#E9EDFE',
    dark: '#004D71'
  },
  white: {
    DEFAULT: "#FFFFFF",
    "base": "#FFFFFF",
    "surface": "#FBFBFC",
  },
  black: {
    DEFAULT: "#000",
    base: '#0A1326',
    "01": '#3B4251',
    "02": '#6C717D',
  },
  gray: {
    base: '#7B8292',
    "01": '#E4E6E9',
    "02": '#F5F5F7',
    "03": '#F2F3F4'
  },
  cyan: {
    base: '#00B2E2',
    "03": '#E0F5FB',
    "02": '#ADE6F5',
  },
  green: {
    base: '#13C16D',
    "01": '#D0F3E2',
    "02": '#E2F7ED',
    "03": "#E8F9F1"
  },
  orange: {
    base: '#FEB603',
    "01": '#FFEEC3',
    "02": '#FEF6E0',
    "03": '#FFB600',
  },
  red: {
    base: "#DB1818",
    "01": "#F8D1D1",
    "02": "#FAE3E3",
  },
  yellow: {
    base: "#EFDD4A"
  },
  support3: {
    base: "#5F4AF5"
  },
  devider: "#eaecf3"
}

const config: Config = {
  content: [
    "./src/pages/**/*.{js,ts,jsx,tsx,mdx}",
    "./src/components/**/*.{js,ts,jsx,tsx,mdx}",
    "./src/app/**/*.{js,ts,jsx,tsx,mdx}",
    "./src/common/**/*.{js,ts,jsx,tsx,mdx}",
  ],
  theme: {
    extend: {
      backgroundImage: {
        "gradient-radial": "radial-gradient(var(--tw-gradient-stops))",
        "gradient-conic":
          "conic-gradient(from 180deg at 50% 50%, var(--tw-gradient-stops))",
      },
      colors
    },
  },
  plugins: [],
};
export default config;
